"use client"

import Link from "next/link"
import { usePathname } from "next/navigation"
import { FileText, Shield, ScrollText, Printer } from "lucide-react"

const legalPages = [
  { label: "Privacy Policy", href: "/privacy", icon: Shield },
  { label: "Terms of Service", href: "/terms", icon: ScrollText },
  { label: "Communications Notice", href: "/compliance", icon: FileText },
]

export function LegalSidebar() {
  const pathname = usePathname()

  const handlePrint = () => {
    window.print()
  }

  return (
    <aside className="w-full lg:w-[240px] flex-shrink-0">
      <div className="lg:sticky lg:top-24">
        <p className="text-xs font-semibold uppercase tracking-[0.15em] text-[#8A8A8A] mb-4">
          Legal Documents
        </p>

        <nav className="space-y-1 mb-6">
          {legalPages.map((page) => {
            const isActive = pathname === page.href
            return (
              <Link
                key={page.href}
                href={page.href}
                className={`flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm transition-colors ${
                  isActive
                    ? "bg-[#EDF1F7] text-[#445e85] font-semibold"
                    : "text-[#4A4A4A] hover:bg-[#F9FAFB] hover:text-[#0F0F0F]"
                }`}
              >
                <page.icon className="w-4 h-4 flex-shrink-0" />
                {page.label}
              </Link>
            )
          })}
        </nav>

        <div className="border-t border-[#E5E7EB] pt-4">
          <button
            onClick={handlePrint}
            className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm text-[#4A4A4A] hover:bg-[#F9FAFB] hover:text-[#0F0F0F] transition-colors w-full"
          >
            <Printer className="w-4 h-4 flex-shrink-0" />
            Print / Save as PDF
          </button>
        </div>
      </div>
    </aside>
  )
}
